import axios from 'axios';
import { loginreq, req } from './axiosFun';

export const login = (params) => { return loginreq("post", "/api/saas/xht/shop/pcLogin", params) };//登录

export const register = (params) => { return loginreq("post", "/api/saas/xht/shop/register", params) };//注册

export const updatePwd = (params) => { return loginreq("post", "/api/saas/xht/shop/updatePwd", params) };//修改密码

export const captcha = (params) => { return loginreq("post", "/api/saas/xht/shop/creatCaptcha", params) };//图形验证码

export const captcha2 = (params) => { return loginreq("get", "/index.php?s=/captcha&r="+Math.random(), params) };//图形验证码

export const shop = (params) => { return req("post", "/api/saas/xht/shop/getShop", params) };

export const addShop = (params) => { return req("post", "/api/saas/xht/shop/xhtAdd", params) };

export const editShop = (params) => { return req("post", "/api/saas/xht/shop/xhtEdit", params) };

export const roomDevice = (params) => { return req("post", "/api/saas/xht/shop/shopRoomDevice", params) };

export const tableDevice = (params) => { return req("post", "/api/saas/xht/shop/shopTableDevice", params) };

export const shopEmployee = (params) => { return req("post", "/api/saas/xht/shop/shopEmployee", params) };

export const mt = (params) => { return req("post", "/api/saas/xht/shop/mt", params) };

export const dou = (params) => { return req("post", "/api/saas/xht/shop/dou", params) };

export const tuan = (params) => { return req("post", "/api/saas/xht/shop/tuan", params) };

export const coupon = (params) => { return req("post", "/api/saas/xht/shop/coupon", params) };

export const userList = (params) => { return req("post", "/api/saas/xht/shop/queryUser", params) };

export const userBalance = (params) => { return req("post", "/api/saas/xht/shop/checkUserBalance", params) };

// 店铺列表接口
export const getShopList = (params) => { return req("post", "/api/saas/xht/shop/getShopList", params) }

// 包厢列表
export const getRoomList = (params) => { return req("post", "/api/saas/xht/shop/getRoomList", params) }

//台桌列表
export const getTableList = (params) => { return req("post", "/api/saas/xht/shop/getTableList", params) }




// WEBPACK FOOTER //
// ./src/api/shop.js